import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorker } from './utils/pushNotifications';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA push notifications (prod by default)
if (
  'serviceWorker' in navigator &&
  (import.meta.env.PROD || import.meta.env.VITE_ENABLE_SW_DEV === 'true')
) {
  registerServiceWorker().catch((error) => {
    console.error('Failed to register service worker:', error);
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
